import { memo } from 'react';

import {
  Guidingtip,
  GUIDINGTIP_ALIGNS,
  GUIDINGTIP_POSITIONS,
  GUIDINGTIP_THEMES,
  useOnboarding,
} from '@wg/wows-react-uikit';

import { ONBOARDING_GUIDES, ONBOARDING_GUIDES_CONFIG } from '~/const/onboarding';

import { t } from '~/helpers/localization';

import styles from './ClanHub.module.scss';
import ClanHubTile, { CLAN_HUB_TILE_SIZE } from './ClanHubTile/ClanHubTile';

import type { HubTileModel } from './clanHub.tiles.build';
import type { ROLE_NAMES } from '~/roles';

interface ClanHubTilesActivitiesProps {
  tiles: HubTileModel[];
  isClanMember?: boolean;
  currentRoleName: ROLE_NAMES | null;
  onClick: () => void;
}

const ClanHubTilesActivities = ({
  tiles,
  isClanMember = false,
  currentRoleName = null,
  onClick,
}: ClanHubTilesActivitiesProps) => {
  const { isCurrentStepCompleted } = useOnboarding({
    stepName: ONBOARDING_GUIDES.CLANHUB_NAV_ACTIVITIES,
  });

  const content = tiles.map((tile) => (
    <ClanHubTile
      tile={tile}
      size={CLAN_HUB_TILE_SIZE.SMALL}
      isClanMember={isClanMember}
      currentRoleName={currentRoleName}
      onClick={onClick}
      key={tile.id}
    />
  ));

  if (!isClanMember || isCurrentStepCompleted) {
    return <div className={styles.hubTilesSmall}>{content}</div>;
  }

  return (
    <Guidingtip
      className={styles.hubTilesSmall}
      name={ONBOARDING_GUIDES_CONFIG.CLANHUB_NAV_ACTIVITIES.name}
      header={ONBOARDING_GUIDES_CONFIG.CLANHUB_NAV_ACTIVITIES.header}
      content={ONBOARDING_GUIDES_CONFIG.CLANHUB_NAV_ACTIVITIES.content}
      position={GUIDINGTIP_POSITIONS.BOTTOM}
      align={GUIDINGTIP_ALIGNS.CENTER}
      theme={GUIDINGTIP_THEMES.CLIENT}
      delay={1000}
      withBeacon={false}
      isActionBtnVisible
      actionBtnText={t('Закрыть')}
    >
      {content}
    </Guidingtip>
  );
};

export default memo(ClanHubTilesActivities);
